<template>
  <v-container fluid grid-list-lg>
    <v-layout text-xs-center row wrap>
      <Saver v-for="saver in savers" :id="saver.id" :key="saver.id" :title="saver.title" :saved="saver.saved" :step="saver.step" :total="saver.total"/>
      <SettingDialog/>
    </v-layout>
  </v-container>
</template>

<script>
import Saver from "../components/Saver";
import SettingDialog from "../components/SettingDialog"
export default {
  components: {
    Saver, SettingDialog
  },
  computed: {
    savers: function() {
      return this.$store.getters.saverSet;
    }
  }
};
</script>
